// extracted by mini-css-extract-plugin
var _1 = "MonthDay-moduleMonthDay__TWPsN Day-moduleDay__tTwxX";
var _2 = "MonthDay-modulecurrent__zlOdZ";
var _3 = "MonthDay-moduletoday__Da2Ws";
export { _1 as "MonthDay", _2 as "current", _3 as "today" }
